export const getBranch = () => {
  switch (window.MLBBest.envVariables.ENV) {
    case "prod":
      return "master";
    case "stg":
      return "stage";
    case "dev":
      return "develop";
    default:
      return window.MLBBest.envVariables.BRANCH;
  }
};
